export default __webpack_public_path__ + "static/media/Mask Group 130.cf2aacca.svg";